import { 
  CogIcon
} from '@heroicons/react/outline';

import { TableColumn, TableTemplate } from './types';

// Import all templates
import { instagramProspectingTemplate, tiktokProspectingTemplate } from './templates/prospecting';
import { trackOutreachTemplate } from './templates/outreach';
import { collectShippingTemplate } from './templates/logistics';
import { shopifyIntegrationTemplate } from './templates/shopify';

// Helper to convert unified template columns to backend format
export const convertTemplateColumnsToBackend = (columns: TableColumn[]): TableColumn[] => {
  return columns.map(col => {
    const converted = { ...col };
    
    // Convert 'shopify_action' to backend shopify with discount_code subtype
    if (col.cell_type === 'shopify_action') {
      converted.cell_type = 'shopify';
      if (!(converted as any).shopify_config) {
        (converted as any).shopify_config = {};
      }
      (converted as any).shopify_config.subtype = 'discount_code';
    }
    
    // Shopify columns with discount_code subtype are already in the correct format
    // No conversion needed for direct 'shopify' type
    
    return converted;
  });
};

// Organized table templates by workflow stage
export const TABLE_TEMPLATES: TableTemplate[] = [
  instagramProspectingTemplate,
  tiktokProspectingTemplate,
  trackOutreachTemplate,
  collectShippingTemplate,
  shopifyIntegrationTemplate
];

// Helper function to get template by ID
export const getTemplateById = (templateId: string): TableTemplate | undefined => {
  return TABLE_TEMPLATES.find(template => template.id === templateId);
};

// Helper function to get icon component by template ID
export const getTemplateIcon = (templateId?: string) => {
  const template = templateId ? getTemplateById(templateId) : null;
  return template?.icon || CogIcon;
};

// Helper function to get templates by category
export const getTemplatesByCategory = () => {
  return {
    prospecting: [],
    outreach: [],
    negotiation: [],
    logistics: [],
    tracking: []
  };
};
